import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as NotificationActionCreators from "../../actions/notification.actions";
import Notifications, { notify } from 'react-notify-toast';

interface ISnackbarNotificationsProps {
    message: string;
    messageType: string;
    onClearNotification: Function;
}

interface ISnackbarNotificationsState {
    open: boolean;
    message: string;
    messageType: string;
}

class SnackbarNotification extends React.Component<ISnackbarNotificationsProps, ISnackbarNotificationsState> {
    constructor(props: ISnackbarNotificationsProps) {
        super(props)

        let open = false;
        if (props.message) {
            if (props.message !== "") {
                open = true;
            }
        }
        this.state = {
            open: open,
            message: props.message,
            messageType: props.messageType
        }
        this.handleClose = this.handleClose.bind(this);
    }

    timer;

    componentDidMount() {
        
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.message !== prevProps.message) {
            let open = false;
            if (this.props.message) {
                if (this.props.message !== "") {
                    open = true;
                }
                this.timer = setTimeout(() => this.handleClose(null, null), 3000);
            }
            this.setState({ open: open, message: this.props.message, messageType: this.props.messageType });
        }
    }

    handleClose(event, reason) {
        if (reason === "clickaway") {
            return;
        }
        this.setState({ open: false, message: "" }, this.props.onClearNotification());
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    render() {
        let notification;
        if (this.state.open) {
            if (this.state.messageType == "success") {
                notification = (
                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                        <button type="button" className="close" onClick={() => this.handleClose(null, null)} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        {this.state.message}
                    </div>
                );
            } else {
                notification = (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <button type="button" className="close" onClick={() => this.handleClose(null, null)} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        {this.state.message}
                    </div>
                );
            }
        }
        return (
            <div>
                {notification}
            </div>
        );
    }
}

const getNotificationMessage = (notification) => {
    if (notification) {
        return notification.message
    }
    return "";
}

const getNotificationMessageType = (notification) => {
    if (notification) {
        return notification.messageType || "";
    }
    return "";
}

const mapStateToProps = state => {
    return {
        message: getNotificationMessage(state.notification),
        messageType: getNotificationMessageType(state.notification),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            onClearNotification: NotificationActionCreators.notificationHide
        },
        dispatch
    );
};

const NotificationContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SnackbarNotification)

export default NotificationContainer


// WEBPACK FOOTER //
// ./src/components/Controls/Notification.tsx